import { render, staticRenderFns } from "./UserBreedModal.vue?vue&type=template&id=d145aeb0&scoped=true"
import script from "./UserBreedModal.vue?vue&type=script&lang=js"
export * from "./UserBreedModal.vue?vue&type=script&lang=js"
import style0 from "./UserBreedModal.vue?vue&type=style&index=0&id=d145aeb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d145aeb0",
  null
  
)

export default component.exports